__turbopack_context__.v({
  "aspectBox": "BlockProductSharpnessStory-module-scss-module__L9duHa__aspectBox",
  "block": "BlockProductSharpnessStory-module-scss-module__L9duHa__block",
  "content": "BlockProductSharpnessStory-module-scss-module__L9duHa__content",
  "eyebrow": "BlockProductSharpnessStory-module-scss-module__L9duHa__eyebrow",
  "fade-in": "BlockProductSharpnessStory-module-scss-module__L9duHa__fade-in",
  "flushBottom": "BlockProductSharpnessStory-module-scss-module__L9duHa__flushBottom",
  "flushTop": "BlockProductSharpnessStory-module-scss-module__L9duHa__flushTop",
  "image": "BlockProductSharpnessStory-module-scss-module__L9duHa__image",
  "inner": "BlockProductSharpnessStory-module-scss-module__L9duHa__inner",
  "innerAspect": "BlockProductSharpnessStory-module-scss-module__L9duHa__innerAspect",
  "innerContent": "BlockProductSharpnessStory-module-scss-module__L9duHa__innerContent",
  "isReveal": "BlockProductSharpnessStory-module-scss-module__L9duHa__isReveal",
  "overlay": "BlockProductSharpnessStory-module-scss-module__L9duHa__overlay",
  "overlayCloseButton": "BlockProductSharpnessStory-module-scss-module__L9duHa__overlayCloseButton",
  "root": "BlockProductSharpnessStory-module-scss-module__L9duHa__root",
  "theme--makers-reserve": "BlockProductSharpnessStory-module-scss-module__L9duHa__theme--makers-reserve",
});
